import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';
import { KPI_GREEN, KPI_RED, KPI_YELLOW } from '../../../../../core/chart/colors';

const ContentCourseFailureAttemptRateGauge = (props) => (
  <KpiChart
    title="Failures over attempts"
    description="The percentage represents the number of failed attempts out of all attempts. The exercises which represent this number are: Single Choice Text, Single Choice Audio, Single Choice Image, Dictation, Gap Fill, Gap Fill Select, Gap Fill Multiple, True or False, Unscramble Drag and Drop, Unscramble Speech Recognition, Multiple Choice Text, Unscramble Text, Meanings Associating, Grammar Check and Dialogue Option."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 5, 10, 25, 35, 40]}
    stepSize={5}
    reverseColors={true}
    onClickHistory={props.onClickHistory}
    formatter={props.formatter}
    colorRules={[
      {
        backgroundColor: KPI_RED,
        rule: '(%v >= 0 && %v < 5) || %v >= 35',
      },
      {
        backgroundColor: KPI_YELLOW,
        rule: '(%v >= 5 && %v < 10) || (%v >= 25 && %v < 35)',
      },
      {
        backgroundColor: KPI_GREEN,
        rule: '%v >= 10 && %v < 25',
      },
    ]}
  />
);

ContentCourseFailureAttemptRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

export default ContentCourseFailureAttemptRateGauge;
